import React from "react";
import { useSelector } from "react-redux";
import classes from "./FileEditor.module.css";
import PdfEditor from "./Files/PdfEditor";

const fileEditorTypesEnum = {
    "pdf": PdfEditor
}
const fileTypesEnum = {
    "application/pdf": "pdf",
}
// לבנתיים יש רק קובץ מסוג pdf אבל זה בנוי בצורה שתומכת בכמה סוגי קבצים
const FileEditor = ({ data,id, setContentData, addListOfContents }) => {

    const { texts } = useSelector(state => state.translate);

    const handleFileUplaod = (event) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (!fileTypesEnum[file.type]) {
                alert(texts.fileNotSupported)
                return;
            }
            const url = URL.createObjectURL(file);
            setContentData({ url: url, type: fileTypesEnum[file.type] })
        }
    }

    return <div className={classes.FileEditor}>
        <div className={classes.HeaderInput}>
            <input type={'file'} onChange={handleFileUplaod} accept={"application/pdf"} className={classes.InputFile}></input> 
            <span className={classes.BeforeInputFile}>{texts.chooseFile}</span>
        </div>
        {data && <div className={classes.FileEditorWrap}>
            {(() => {
                let Compnent = fileEditorTypesEnum[data.type];
                return <Compnent slideId={id} data={data} addListOfContents={addListOfContents}></Compnent>
            })()}
        </div>
        }

    </div>
}

export default FileEditor;